import Vue from 'vue';
import VueRouter from 'vue-router';
import { routers } from './router';

Vue.use(VueRouter);

export const router = new VueRouter({
  // base: '/',
  mode: 'history',
  routes: routers
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // console.log(to.meta.title);
    document.title = to.meta.title + ' - ' + 'Netbank'
  }
  next()
})




// WEBPACK FOOTER //
// ./src/router/index.js